import { inject } from '@angular/core';
import type { Environment } from '~core/tokens/environment.token';
import { ENVIRONMENT } from '~core/tokens/environment.token';

const getAuthEndpoints = (baseUrl: string) => ({
    v2: {
        login: `${baseUrl}/login`,
        logintoken: `${baseUrl}/logintoken`,
        mfacheck: `${baseUrl}/mfacheck`,
        //getip: `${baseUrl}/get-my-ip`,
        profile: `${baseUrl}/profile`,
    },
    v3: {
        login: `${baseUrl}/v3/login`,
        logintoken: `${baseUrl}/v3/logintoken`,
        mfacheck: `${baseUrl}/v3/mfacheck`,
        profile: `${baseUrl}/v3/profile`,
    }
});

const getProductCategoryEndpoints = (baseUrl: string) => ({
    v2: {
        list: `${baseUrl}/product/back`,
    },
});


const getCountryEndpoints = (baseUrl: string) => ({
    v2: {
        list: `${baseUrl}/countries`,
    },
});

const getShippingEndpoints = (baseUrl: string) => ({
    v2: {
        calculate: `${baseUrl}/shipping`,
    },
});

const getPadOrderEndpoints = (baseUrl: string) => ({
    v2: {
        padorder: `${baseUrl}/pad`,
    },
});

const getPaymentsEndpoints = (baseUrl: string) => ({
    v2: {
        payments: `${baseUrl}/payments`,
    },
});


export const getEndpoints = () => {
    const environment = inject<Environment>(ENVIRONMENT);
    //console.log('Environment:', environment);
    return {
        auth: getAuthEndpoints(environment.apiLogUrl),
        product: getProductCategoryEndpoints(environment.apiUrl),
        country: getCountryEndpoints(environment.apiUrl),
        shipping: getShippingEndpoints(environment.apiUrl),
        order: getPadOrderEndpoints(environment.apiUrl),
        payments: getPaymentsEndpoints(environment.apiUrl),
    } as const;
};